<template>
    <q-layout view="hHh lpR fFf" style="display: grid">
        <q-page-container :style="$q.screen.width < 485 ? `` : `margin: auto`">
            <q-card
                flat
                bordered
                :class="$q.screen.width < 485 ? `my-card-mobile` : `my-card`"
                class="q-pt-lg"
            >
                <q-card-section>
                    <div class="row justify-center">
                        <q-img
                            basic
                            v-if="$q.screen.width < 485"
                            contain
                            width="50px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                        <q-img
                            basic
                            v-else
                            contain
                            width="100px"
                            :src="require('@/assets/logo-villa-mobile.svg')"
                        />
                    </div>
                    <div class="row justify-center">
                        <div class="text-h6">Villa market</div>
                    </div>
                </q-card-section>

                <q-card-section>
                    <div
                        class="row justify-center items-center"
                        :style="$q.screen.width < 485 ? `min-height:180px` : ``"
                    >
                        <q-img
                            basic
                            contain
                            height="120px"
                            :src="
                                require(`@/assets/${
                                    isSuccess
                                        ? 'success-icon-blue'
                                        : 'fail-icon'
                                }.png`)
                            "
                        />
                    </div>
                    <div class="row justify-center">
                        <div v-if="isSuccess" class="text-h6">
                            {{ amount | toFixed2 }}
                        </div>
                        <div
                            v-else
                            class="text-h6 text-red"
                        >
                            {{ reason }}
                        </div>
                    </div>
                    <div class="row justify-center">
                        <div v-if="isSuccess" class="text-h6">
                            Paid Successfully
                        </div>
                    </div>

                    <div style="padding: 50px 0px">
                        <q-separator />
                    </div>

                    <div class="row justify-center">
                        <div v-if="orderId" class="text-h6 text-primary">
                            Order #{{ orderId }}
                        </div>
                    </div>
                    <div class="row justify-center">
                        <div style="font-size: 17px; color: #afafaf">
                            {{ date }}
                        </div>
                    </div>
                </q-card-section>

                <q-card-section>
                    <span class="text-subtitle2">
                        <a href="https://shop.villamarket.com/terms">
                            Terms and conditions
                        </a>
                        and
                        <a href="https://shop.villamarket.com/privacy-policy">
                            Privacy Policy
                        </a>
                    </span>
                </q-card-section>
            </q-card>
        </q-page-container>
    </q-layout>
</template>

<script>
import dayjs from "dayjs";
export default {
    name: "Thankyou",
    data() {
        return {
            amount: null,
            status: null,
            reason: null,
            orderId: null,
        };
    },
    computed: {
        isSuccess() {
            return this.status === "success";
        },
        date() {
            return dayjs().format("DD/MM/YYYY h:mm A");
        },
    },
    beforeRouteEnter(to, from, next) {
        if (to) {
            if (to.query) {
                return next((vm) => {
                    vm.amount = parseFloat(to.query.amount);
                    vm.status = to.query.status;
                    vm.reason = to.query.reason;
                    vm.orderId = to.query.orderId;
                    vm.reason = to.query.reason;
                });
            }
        }
        console.log("beforeRouteEnter Thankyou page", to, from);
        next();
    },
};
</script>

<style scoped>

.my-card {
    min-width: 360px;
}

.my-card-mobile {
    width: 100vw;
    height: 100vh;
}

.no-bold {
    font-weight: normal;
}

</style>
